import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mask-loader-private',
  templateUrl: './mask-loader-private.component.html',
  styleUrls: ['./mask-loader-private.component.scss']
})
export class MaskLoaderPrivateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
